/**
 * Suppress benign ResizeObserver loop errors before React / webpack overlay load.
 * Must run in capture phase so CRA error overlay does not treat them as fatal.
 */
(function suppressResizeObserverLoopError() {
  if (typeof window === 'undefined') return;

  const isRO = (msg: unknown): boolean =>
    typeof msg === 'string' && msg.indexOf('ResizeObserver loop') !== -1;

  window.addEventListener(
    'error',
    (event) => {
      if (isRO(event.message)) {
        event.stopImmediatePropagation();
        if (typeof event.preventDefault === 'function') event.preventDefault();
      }
    },
    true,
  );

  const originalOnError = window.onerror;
  window.onerror = function (message, source, lineno, colno, error) {
    if (isRO(message) || (error && isRO(error.message))) {
      return true;
    }
    if (typeof originalOnError === 'function') {
      return originalOnError(message, source, lineno, colno, error);
    }
    return false;
  };

  const originalConsoleError = console.error.bind(console);
  console.error = (...args: unknown[]) => {
    if (args.length && isRO(String(args[0]))) {
      return;
    }
    if (
      args.length > 1 &&
      typeof args[0] === 'string' &&
      args[0].indexOf('%s') !== -1 &&
      isRO(String(args[1]))
    ) {
      return;
    }
    originalConsoleError(...args);
  };
})();
